import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["current", "dataNum", "activePage", "onSelect", "showJump", "dataNumSelect", "pageSizeOptions", "onShowSizeChange", "onPageSizeChange", "onDataNumSelect", "pageSize", "size", "total", "onChange", "defaultCurrent", "defaultActivePage", "defaultDataNum", "defaultPageSize", "showQuickJumper"];
import "core-js/modules/es6.array.sort.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Pagination from './Pagination';
var sizeMap = {
  small: 'sm',
  sm: 'sm',
  large: 'lg',
  lg: 'lg'
};
var defaultProps = {
  dataNumSelect: ['10', '20', '30', '50', '100', '200', '500', '1000'],
  dataNum: 0
};

var PaginationAdapter = /*#__PURE__*/function (_Component) {
  _inherits(PaginationAdapter, _Component);

  var _super = _createSuper(PaginationAdapter);

  function PaginationAdapter(props) {
    _classCallCheck(this, PaginationAdapter);

    return _super.call(this, props);
  }

  _createClass(PaginationAdapter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          current = _this$props.current,
          dataNum = _this$props.dataNum,
          activePage = _this$props.activePage,
          onSelect = _this$props.onSelect,
          showJump = _this$props.showJump,
          dataNumSelect = _this$props.dataNumSelect,
          pageSizeOptions = _this$props.pageSizeOptions,
          onShowSizeChange = _this$props.onShowSizeChange,
          onPageSizeChange = _this$props.onPageSizeChange,
          onDataNumSelect = _this$props.onDataNumSelect,
          pageSize = _this$props.pageSize,
          size = _this$props.size,
          total = _this$props.total,
          onChange = _this$props.onChange,
          defaultCurrent = _this$props.defaultCurrent,
          defaultActivePage = _this$props.defaultActivePage,
          defaultDataNum = _this$props.defaultDataNum,
          defaultPageSize = _this$props.defaultPageSize,
          showQuickJumper = _this$props.showQuickJumper,
          others = _objectWithoutProperties(_this$props, _excluded); // const items = Math.ceil(total / pageSize)


      dataNumSelect = pageSizeOptions || dataNumSelect; // 如果dataNumSelect里没有当前指定的页码，则将pageSize加入到dataNumSelect，并不可修改

      if (pageSize && dataNumSelect.indexOf(pageSize + '') === -1) {
        dataNumSelect.push(pageSize + '');
        dataNumSelect = dataNumSelect.sort(function (a, b) {
          return a - b;
        });
      } else if (defaultPageSize && dataNumSelect.indexOf(defaultPageSize + '') === -1) {
        dataNumSelect.push(defaultPageSize + '');
        dataNumSelect = dataNumSelect.sort(function (a, b) {
          return a - b;
        });
      } // 优先级为pageSize > defaultPageSize > dataNum


      if (dataNumSelect.indexOf(pageSize + '') > -1) {
        dataNum = dataNumSelect.indexOf(pageSize + '');
      } else if (dataNumSelect.indexOf(defaultPageSize + '') > -1) {
        dataNum = dataNumSelect.indexOf(defaultPageSize + '');
      } else if (dataNum === undefined) {
        dataNum = 0;
      }

      return /*#__PURE__*/React.createElement(Pagination, _extends({
        showJump: "showQuickJumper" in this.props ? showQuickJumper : showJump,
        activePage: current || activePage,
        defaultActivePage: defaultCurrent || defaultActivePage,
        dataNum: dataNum //每页显示条数在 dataNumSelect 数组中的下标 index。例如每页显示 15 条，那么 dataNum 的值应为 '15' 在 ['5','10','15','20'] 中的下标：2
        ,
        pageSize: pageSize // 指定的分页数量
        ,
        defaultPageSize: defaultPageSize,
        dataNumSelect: dataNumSelect,
        size: sizeMap[size],
        total: isNaN(total) ? 0 : total,
        onSelect: onChange || onSelect,
        onDataNumSelect: onPageSizeChange || onShowSizeChange || onDataNumSelect // items={items}

      }, others));
    }
  }]);

  return PaginationAdapter;
}(Component);

PaginationAdapter.defaultProps = defaultProps;
export default PaginationAdapter;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-pagination/src/index.js